import React from "react";
import { connect } from "react-redux";
import type { MapStateToProps } from "react-redux";
import { makeGetItemErrorsForId } from "../../../../reducers/flowItems";
import Icon from "@material-ui/core/Icon";

type Props = {
    id: number,
    // Redux
    itemErrors: Array<string>,
};

class FlowItemErrorIcon extends React.Component<Props> {
    render() {
        const { itemErrors } = this.props;
        if (!itemErrors || Object.keys(itemErrors).length == 0) {
            return null;
        }
        return (
            <div className="alert alert-warning-original flow-item-warnings">
                {itemErrors &&
                    itemErrors.map(x => (
                        <div key={x}>
                            <Icon style={{ marginRight: "10px", position: "relative", top: "2px" }}>error_outline</Icon>
                            {x}
                        </div>
                    ))}
            </div>
        );
    }
}

const mapStateToProps: MapStateToProps<*, *, *> = () => {
    const getItemErrorsForId = makeGetItemErrorsForId();
    return (state, ownProps) => ({
        itemErrors: getItemErrorsForId(state, ownProps),
    });
};

const mapDispatchToProps = null;
const FlowItemErrorIconC = connect(mapStateToProps, mapDispatchToProps)(FlowItemErrorIcon);

export default FlowItemErrorIconC;
